<script setup>
  import { defineProps, defineEmits } from 'vue';

defineProps({
  show: Boolean,
  boxdata: Object
});

const emit = defineEmits(['close', 'add-new-box', 'add-same-box', 'checkout']);

function handleNewBox() {
  emit('add-new-box');
  emit('close');
}

function handleSameBox() {
  emit('add-same-box');
  emit('close');
  
  setTimeout(() => {
    const whereToElement = document.querySelector('.d-flex.flex-column.mt-5');
    if (whereToElement) {
      whereToElement.scrollIntoView({ behavior: "smooth" });
      const offset = -75;
      const elementPosition = whereToElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition + offset,
        behavior: "smooth",
      });
    }
  }, 100);
}

function handleCheckout() {
  emit('checkout');
  emit('close');
}
</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container rounded-4 d-flex flex-column">
          <div class="modal-body d-flex flex-column">
            <img
              :src="boxdata?.pickedBox?.acf?.boxpicker_afbeelding?.url ?? boxdata?.pickedBox?.images?.[0]?.src"
              alt="Product Image"
              class="cart-item-image mx-auto rounded-pill"
              style="width: 170px"
            />
            <p class="mt-3 fw-bold fs-2 text-center mx-auto font-anton my-2">Je box is toegevoegd!</p>
            <button
              class="bg-white border fs-15 mt-4 py-3 px-5 rounded-pill"
              @click="handleNewBox"
            >
              Nog een box samenstellen
            </button>
            <button
              class="bg-white fs-15 py-3 px-5 border rounded-pill mt-3"
              @click="handleSameBox"
            >
              Dezelfde box naar iemand anders sturen
            </button>
            <button
              class="bg-red fs-15 text-light py-3 px-5 border-0 rounded-pill mt-3"
              @click="handleCheckout"
            >
              Doorgaan naar afrekenen
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 450px;
  max-width: 100vw;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

@media (max-width: 350px) {
  .modal-container {
    padding: 12px 20px;
  }
}

.modal-body {
  margin: 20px 0;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(1.1);
}

.font-anton {
  font-family: Anton-Regular !important;
}
</style>